import TripList from './trip_list';

export default TripList;
